// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getSkillsList = createAsyncThunk(
  'skills/getSkillsList',
  async (params) => {
    const response = await axios.get(baseUrl() + '/skills', { params })
    return {
      totalRecords: response?.data?.count?.total ?? 0,
      skillsList: response.data.data,
      loader: false
    }
  }
)
export const addSkill = createAsyncThunk(
  'skills/addSkill',
  async ({ name, pageNo, pageSize, parameters }, { dispatch }) => {
    try {
      const res = await axios.post(baseUrl() + '/skills', {
        name
      })
      toast.success(res?.data?.message)
      await dispatch(getSkillsList({ ...parameters, pageNo, pageSize }))
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    } finally {
      dispatch(setLoading(false))
    }
  }
)

export const updateSkill = createAsyncThunk(
  'skills/updateSkill',
  async ({ name, pageNo, pageSize, id, parameters }, { dispatch }) => {
    try {
      const res = await axios.put(baseUrl() + '/skills/' + id, {
        name
      })
      toast.success(res?.data?.message)
      await dispatch(getSkillsList({ pageNo, pageSize, ...parameters }))
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    } finally {
      dispatch(setLoading(false))
    }
  }
)

export const deleteTechnology = createAsyncThunk(
  'skills/deleteSkill',
  async ({ id, pageNo, pageSize, search, params }, { dispatch, getState }) => {
    try {
      dispatch(setLoader())
      const res = await axios.delete(baseUrl() + '/skills/' + id, {
        id
      })
      toast.success(res?.data?.message)
      await dispatch(getSkillsList({ pageNo, pageSize, search, ...params }))
      return id
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
)

export const skills = createSlice({
  name: 'skills',
  initialState: {
    skillsList: [],
    // allSkillList: [],
    selectedSkill: null,
    totalRecords: 0,
    loader: true,
    loading: false,
    params: {
      pageNo: 1,
      pageSize: 25
    },
    selected: null,
    clearFilter: false,
    filterData: null
  },
  reducers: {
    selectTechnology: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    },
    setFilterData: (state, action) => {
      if (action.payload === null) {
        state.filterData = null
      } else {
        state.filterData = action.payload
      }
    },
    selectClearFilter: (state, action) => {
      state.clearFilter = action.payload
    },
    setLoader: (state) => {
      state.loader = !state.loader
    },
    setParams: (state, action) => {
      state.params = {
        // ...state.params,
        ...action.payload
      }
    },
    setLoading: (state, action) => {
      state.loading = action?.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSkillsList.fulfilled, (state, action) => {
        state.skillsList = action.payload.skillsList
        state.totalRecords = action.payload.totalRecords
        state.loader = action.payload.loader
      })
      .addCase(getSkillsList.pending, (state) => {
        state.loader = true
      })
  }
})

export const {
  selectTechnology,
  setLoader,
  setParams,
  selectClearFilter,
  setShowDeletedUser,
  setLoading,
  setFilterData
} = skills.actions

export default skills.reducer
